<template>
  <div class="warning-message">
    <img src="../../assets/waving_hand.svg" aria-hidden />
    <slot />
  </div>
</template>

<style lang="postcss">
.warning-message {
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: space-around;
  padding: 8px;
  border-radius: 22px;
  background-color: #f7f6f3;
  gap: var(--attest-spacing-2);
}
</style>
